import { render, staticRenderFns } from "./objCalendarSelected.vue?vue&type=template&id=ec0c9322&"
import script from "./objCalendarSelected.vue?vue&type=script&lang=ts&"
export * from "./objCalendarSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports